<template>
  <payment-review-modal
    id="fee-review-modal"
    :form-data="modal.data.formData"
    :transaction-type="modal.data.transactionType"
  >
    <data-divider />
    <profile-data-in-modal
      :transaction-party-type="TRANSACTION_PARTY_TYPES.SENDER"
      :profile="modal.data.sender"
      :selected-account="modal.data.senderAccount"
    />
    <data-divider />
    <v-layout
      v-if="!isFeeForPayment"
      class="row--data"
      row
    >
      <v-flex xs4>
        <v-subheader class="v-subheader--dense">Channel</v-subheader>
      </v-flex>
      <v-flex xs8>
        <div id="review-channel">{{ modal.data.formData.channel | channel }}</div>
      </v-flex>
    </v-layout>
    <v-layout
      v-if="isFeeForPayment"
      class="row--data"
      row
    >
      <v-flex xs4>
        <v-subheader class="v-subheader--dense">Fee for payment</v-subheader>
      </v-flex>
      <v-flex xs8>
        <div id="review-fee-for-payment-id">{{ modal.data.formData.paymentId }}</div>
      </v-flex>
    </v-layout>
    <v-layout
      class="row--data"
      row
    >
      <v-flex xs4>
        <v-subheader class="v-subheader--dense">Fee type</v-subheader>
      </v-flex>
      <v-flex xs8>
        <div id="review-fee-type">{{ modal.data.formData.feeType }}</div>
      </v-flex>
    </v-layout>
  </payment-review-modal>
</template>

<script>
  import { mapGetters } from 'vuex'

  // Constants
  import { TRANSACTION_PARTY_TYPES } from '@/models/Transaction'

  // Components
  import PaymentReviewModal from '@/components/payments/ReviewModal/PaymentReviewModal'
  import ProfileDataInModal from '@/components/payments/ReviewModal/ProfileDataInModal'
  import DataDivider from '@/components/payments/ReviewModal/DataDivider'

  export default {
    name: 'FeeReviewModal',
    components: {
      PaymentReviewModal,
      ProfileDataInModal,
      DataDivider
    },
    data () {
      return {
        TRANSACTION_PARTY_TYPES
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      isFeeForPayment () {
        return this.modal.data.formData.paymentId != null && this.modal.data.formData.paymentId !== ''
      }
    }
  }
</script>
